import API from 'services/API';

export default function getRelations(params) {
  return API.request({
    method: 'GET',
    url: '/guardianship/all',
    params,
  });
}
